import styled from "@emotion/styled";

export const PageWrapper = styled.div`
  padding: 24px;
  min-height: 100vh;
`;

export const HeaderArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 28px;
`;

export const TabsRow = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
  background: #f3f4f6;
  padding: 4px;
  border-radius: 12px;
  width: fit-content;
`;

export const Tab = styled.button<{ active: boolean }>`
  padding: 8px 20px;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  background: ${({ active }) => (active ? "#fff" : "transparent")};
  color: ${({ active }) => (active ? "#1f2937" : "#6b7280")};
  box-shadow: ${({ active }) =>
    active ? "0 1px 4px rgba(0,0,0,0.08)" : "none"};

  &:hover {
    color: #1f2937;
  }
`;

export const StatusPill = styled.span<{ status: string }>`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 14px;
  border-radius: 100px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.3px;
  background: ${({ status }) => {
    switch (status) {
      case "Approved":
        return "rgba(16, 185, 129, 0.1)";
      case "Rejected":
        return "rgba(239, 68, 68, 0.1)";
      case "Pending":
        return "rgba(245, 158, 11, 0.1)";
      default:
        return "rgba(107, 114, 128, 0.1)";
    }
  }};
  color: ${({ status }) => {
    switch (status) {
      case "Approved":
        return "#059669";
      case "Rejected":
        return "#dc2626";
      case "Pending":
        return "#d97706";
      default:
        return "#6b7280";
    }
  }};
`;

export const ActionBtn = styled.button<{ variant: "approve" | "reject" }>`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 14px;
  border: none;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-right: 6px;

  background: ${({ variant }) =>
    variant === "approve"
      ? "linear-gradient(135deg, #10b981 0%, #059669 100%)"
      : "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)"};
  color: white;
  box-shadow: ${({ variant }) =>
    variant === "approve"
      ? "0 2px 8px rgba(16, 185, 129, 0.3)"
      : "0 2px 8px rgba(239, 68, 68, 0.3)"};

  &:hover {
    transform: translateY(-1px);
    box-shadow: ${({ variant }) =>
      variant === "approve"
        ? "0 4px 12px rgba(16, 185, 129, 0.4)"
        : "0 4px 12px rgba(239, 68, 68, 0.4)"};
  }

  &:active {
    transform: translateY(0);
  }
`;

export const StoreInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  .logo-wrapper {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    overflow: hidden;
    background: #f3f4f6;
    border: 1px solid #e5e7eb;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .placeholder {
      font-weight: 700;
      font-size: 16px;
      color: #9ca3af;
    }
  }

  .details {
    display: flex;
    flex-direction: column;
    gap: 1px;
  }

  .name {
    font-weight: 600;
    font-size: 14px;
    color: #111827;
    line-height: 1.2;
  }
  .owner-info {
    font-size: 11px;
    color: #6b7280;
    line-height: 1.2;
  }
  .phone {
    font-size: 11px;
    color: #9ca3af;
    display: flex;
    align-items: center;
    gap: 3px;
    margin-top: 1px;
  }
`;

export const AmountCell = styled.div`
  font-weight: 700;
  font-size: 15px;
  color: #1f2937;
`;

export const DateCell = styled.div`
  font-size: 13px;
  color: #6b7280;
`;

export const NoteCell = styled.div`
  font-size: 13px;
  color: #9ca3af;
  font-style: italic;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ModalOverlay = styled.div`
  padding: 28px;
  min-width: 400px;
`;

export const ModalTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 4px 0;
`;

export const ModalSubtitle = styled.p`
  font-size: 13px;
  color: #6b7280;
  margin: 0 0 24px 0;
`;

export const BankDetailsCard = styled.div`
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;

  .title {
    font-size: 11px;
    font-weight: 700;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 12px;
    display: block;
  }

  .qr-section {
    display: flex;
    justify-content: center;
    margin-bottom: 16px;

    img {
      max-width: 180px;
      border-radius: 10px;
      border: 1px solid #e2e8f0;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    }
  }

  .grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }

  .item {
    display: flex;
    flex-direction: column;
    gap: 2px;

    .label {
      font-size: 11px;
      color: #94a3b8;
    }
    .value {
      font-size: 13px;
      font-weight: 600;
      color: #334155;
    }
  }
`;

export const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #f3f4f6;

  .label {
    font-size: 13px;
    color: #6b7280;
  }
  .value {
    font-size: 14px;
    font-weight: 600;
    color: #1f2937;
  }
`;

export const InputGroup = styled.div`
  margin-bottom: 18px;

  label {
    display: block;
    font-size: 13px;
    font-weight: 600;
    color: #374151;
    margin-bottom: 6px;
  }

  input,
  textarea {
    width: 100%;
    padding: 10px 14px;
    border: 1.5px solid #e5e7eb;
    border-radius: 10px;
    font-size: 14px;
    transition: border-color 0.2s;
    outline: none;
    background: #f9fafb;
    font-family: inherit;

    &:focus {
      border-color: #667eea;
      background: white;
    }
  }
`;
